import '../../base/sass/style.sass';

import baseConfig from '../../base/js/config';

import gameShell from '../../base/js/game-shell';
import game from '../../base/js/game';

import resize from '../../base/js/managers/resize';
import assets from '../../base/js/managers/assets';
import server from '../../base/js/managers/server';
import logger from '../../base/js/managers/logger';
import fakeServer from '../../base/js/managers/fake-server';
import alert from '../../base/js/managers/alert';
import hud from '../../base/js/managers/hud';
import gui from '../../base/js/managers/gui';
import guiDesktop from '../../base/js/managers/gui-desktop';
import bet from '../../base/js/managers/bet';

import Main from '../../base/js/screens/Main';

import rules from './managers/rules';
import wincomb from './managers/wincomb';

import { lib, ss } from '../temp/maket';
import atlas from '../temp/img/maket_atlas_.png';

const winTable = [
  [0, 10, 250, 2500, 10000],
  [0, 0, 25, 125, 500],
  [0, 0, 25, 125, 500],
  [0, 0, 25, 125, 500],
  [0, 0, 25, 125, 500],
  [0, 0, 25, 125, 500],
  [0, 0, 10, 50, 125],
  [0, 0, 10, 50, 125],
  [0, 0, 5, 25, 100],
  [0, 0, 5, 25, 100],
  [0, 0, 5, 25, 100],
  [0, 0, 5, 25, 100],
  [0, 2, 5, 20, 500],
];

const config = Object.assign({}, baseConfig, {
  gameId: 'vozdushny-desant',
  scatter: 12,
  wild: 0,
  freeSpinsMulti: 1,
  freeSpinsAmount: 25,
  double: true,
  lines: [1, 3, 5, 7, 9],
  winTable,
});

gameShell.init({
  assets: {
    atlas,
    lib,
    ss,
  },
  managers: {
    realServer: server,
    fakeServer,
    logger,
    wincomb,
    resize,
    assets,
    rules,
    alert,
    hud,
    gui,
    bet,
    guiDesktop,
  },
  screens: {
    Main,
  },
  game,
  config,
});



// WEBPACK FOOTER //
// ./js/index.js